import React, { useEffect } from 'react';
import Button from '../Button/Button';
import showButton from '../../../assets/images/show.png'
import dontShowButton from '../../../assets/images/dont-show.png'
import './LoginForm.css';

const LoginForm = (props) => {
    return (
        <div className="LoginForm">
            <h3 className="LoginForm__title">{props.title}</h3>

            <form onSubmit={props.submit}>
                <div className="LoginForm__formContent">
                    <input onKeyPress={props.keyPress} style={props.errorUsername ? {border: "1px solid #E34A4E"} : null} placeholder="логин" name="username" className="LoginForm__input" onChange={props.loginOnChange} type="text" />
                    <div className="LoginForm__errorFrame">
                        {props.errorUsername ? <p className="LoginForm__errorText">Неправильный логин. Проверьте написание и попробуйте еще раз.</p> : null}
                    </div>
                    <label className='LoginForm__password_label'>
                        <input onKeyPress={props.keyPress} style={props.errorPassword ? {border: "1px solid #E34A4E"} : null} placeholder="пароль" name="password" className="LoginForm__input" onChange={props.passwordOnChange} type={props.showPassword? 'text': "password"} />
                        <img onClick={props.toggleShowPassword} src={props.showPassword ? dontShowButton: showButton  } alt='show'/>  
                    </label>  
                    <div className="LoginForm__errorFrame">
                        {props.errorPassword ? <p className="LoginForm__errorText">Неправильный пароль. Проверьте раскладку и попробуйте еще раз.</p> : null}
                    </div>
                    <label name="remember" htmlFor="remember">
                        <input checked={props.checkboxValue} className="LoginForm__checkbox" id="remember" name="remember" onChange={props.checkOnChange} type="checkbox" />
                        <p className="LoginForm__checkbox--text">Запомнить меня</p>
                    </label>
                    <Button 
                        class="LoginForm__input--pushUp"
                        name={props.buttonName}
                        width={props.buttonWidth}
                    />
                    
                </div>
            </form>
        </div>
    )
}

export default LoginForm;